<app-register *transloco="let t">
  <app-carousel-register [previousPageLabel]="t(previousPageLabel)"
                         [finishLabel]="t(finishLabel)"
                         (finish)="register()"
                         [pages]="carouselPages"
                         [firstPageLabel]="t(firstPageLabel)"
                         [secondPageLabel]="t(secondPageLabel)"
                         [thirdPageLabel]="t(thirdPageLabel)"
                         [businessData]="businessData"
                         [equipmentData]="equipmentData"
                         [businessRepresentative]="businessRepresentative"
                         [termsFormGroup]="termsFormGroup"
                         [recaptchaFormGroup]="recaptchaFormGroup"
                         [creatingAccount]="creatingAccount"
                         [errorMessage]="errorMessage.feedback || ''"
                         content>
  </app-carousel-register>
</app-register>
